import PropTypes from 'prop-types'
import { H4, Caption } from '../../../cdl-react-components/components'
import Link from '../../../Utilities/Link'
import { formatResultsItemDate } from '../../../../utilities'

const articleItem = (props) => {
    const { article } = props

    let caption = ''
    if (!!article.articleTypes) {
        const tokens = new Set(article.articleTypes.split(',').map(x => x.trim()))
        caption += Array.from(tokens).join(', ')
    }
        

    return (
        <Link
            href={'/article/' + article.id}
            onClick={props.handleResultSelect}
            className={'results__item' + (new Date(article.publication_date) > Date.now() ? ' unpublished': '')}
            title={article.title}>
            <H4>{article.title}</H4>
            { article.subtitle && <Caption>{article.subtitle}<br/></Caption> }
            <Caption>{caption} | {formatResultsItemDate(article)}</Caption>
        </Link>
    )
}

articleItem.propTypes = {
    article: PropTypes.object.isRequired,
    handleResultSelect: PropTypes.func.isRequired
}

export default articleItem